import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=3ee88890&"
import script from "./ChinaMap.vue?vue&type=script&lang=js&"
export * from "./ChinaMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports